import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import Wedding from './pages/Wedding';
import About from './pages/About';
import Contact from './pages/Contact';
import BabyShoot from './pages/BabyShoot';
import Stills from './pages/Stills';
import Anniversary from './pages/Anniversary';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="min-h-screen bg-charcoal">
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/wedding" element={<Wedding />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/baby-shoot" element={<BabyShoot />} />
          <Route path="/stills" element={<Stills />} />
          <Route path="/anniversary" element={<Anniversary />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
